import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RequestTusVideoUploadMutation } from "../graphql/mutations";
import type {
  RequestTusVideoUploadMutationType,
  RequestTusVideoUploadMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRequestTusVideoUploadMutation = (
  options?: MutationHookOptions<
    RequestTusVideoUploadMutationType,
    RequestTusVideoUploadMutationVariablesType
  >
) => {
  return useMutation<
    RequestTusVideoUploadMutationType,
    RequestTusVideoUploadMutationVariablesType
  >(RequestTusVideoUploadMutation, options);
};
